import React from "react";
import { Route } from "react-router-dom";
import { DistributionNormalCard } from "./NormalCard";
import { DistributionNormalUIProvider } from "./NormalUIContext";
import { PrivateRoute } from "../../../../PrivateRoute";
import { RoleChecker } from "../../../../RoleChecker";

export function DistributionNormalPage({ history }) {
  const distributionNormalUIEvents = {
    newDistributionNormalIndividuButtonClick: () => {
      history.push("/kurban/distribution/normal/individual/new");
    },
    newDistributionNormalOrganizationButtonClick: () => {
      history.push("/kurban/distribution/normal/organization/new");
    },
    openEditDistributionNormalIndividualPage: (id) => {
      history.push(`/kurban/distribution/normal/individual/${id}/edit`);
    },
    openEditDistributionNormalOrganizationPage: (id) => {
      history.push(`/kurban/distribution/normal/organization/${id}/edit`);
    },
    openDeleteDistributionNormalPage: (id) => {
      history.push(`/kurban/distribution/normal/${id}/delete`);
    },
  };

  return (
    <DistributionNormalUIProvider
      distributionNormalUIEvents={distributionNormalUIEvents}
    >
      <DistributionNormalCard history={history} />
    </DistributionNormalUIProvider>
  );
}
